var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('vue-headful',{attrs:{"title":_vm.dynamicTitle}}),_c('div',{staticClass:"container page-margin"},[_c('div',{staticClass:"contents"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.jsonHtml[_vm.locale])}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }